import type { useAuth } from "@assetwatch/auth";
import type { TFunction } from "i18next";

type AuthUser = ReturnType<typeof useAuth>["user"];

const askReliNavKeyByPath = new Map<string, string>([
  ["/", "enterprise.routes.appShell.nav.overview"],
  ["/assets", "enterprise.routes.appShell.nav.assets"],
  ["/team", "enterprise.routes.appShell.nav.team"],
  ["/maturity", "enterprise.routes.appShell.nav.maturityModel"],
  ["/settings", "enterprise.routes.appShell.nav.settings"],
  ["/map", "enterprise.routes.appShell.nav.map"],
  ["/cmms", "enterprise.routes.appShell.nav.cmmsIntelligence"],
  ["/achievements", "enterprise.routes.appShell.nav.achievements"],
  ["/sandbox", "enterprise.routes.appShell.nav.sandboxSummary"],
  ["/ask-reli", "enterprise.routes.appShell.nav.askReli"],
]);

export function getAskReliUserName(user: AuthUser | null | undefined) {
  const firstName = user?.firstName?.trim();
  if (firstName) {
    return firstName;
  }

  const name = user?.name?.trim().split(/\s+/)[0];
  if (name) {
    return name;
  }

  const emailName = user?.email?.split("@")[0]?.trim();
  return emailName || undefined;
}

export function getAskReliContextLabel(
  t: TFunction,
  pathname: string | undefined,
) {
  if (!pathname) {
    return undefined;
  }

  if (pathname.startsWith("/facilities/")) {
    return t("enterprise.routes.appShell.nav.facilityDetails");
  }

  const navKey = askReliNavKeyByPath.get(pathname);
  return navKey ? t(navKey) : undefined;
}
